import { render, staticRenderFns } from "./SanteActifs.vue?vue&type=template&id=b59ad92a&"
import script from "./SanteActifs.vue?vue&type=script&lang=js&"
export * from "./SanteActifs.vue?vue&type=script&lang=js&"
import style0 from "./SanteActifs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports